import { useMemo } from "react";
import { __ } from "../utils/i18n.js";
function useFomoCouponText(textParams) {
    return useMemo(()=>[
            __("{{percent}}Save %1$d%%{{/percent}} with the coupon {{span}}%2$s{{/span}}. Still valid for {{countdown/}} hours.", textParams[0], textParams[1]),
            __("{{percent}}Save %1$d%%{{/percent}} with coupon {{span}}%2$s{{/span}}. Still valid for {{countdown/}} hours. Hurry up!", textParams[0], textParams[1]),
            __("{{percent}}Save %1$d%%{{/percent}} with the coupon {{span}}%2$s{{/span}}. Only valid today for {{countdown/}} more hours.", textParams[0], textParams[1]),
            __("Order today and {{percent}}save %1$d%%{{/percent}} with coupon {{span}}%2$s{{/span}}!", textParams[0], textParams[1]),
            __("Use coupon {{span}}%2$s{{/span}} and {{percent}}save %1$d%%{{/percent}}. Expires in {{countdown/}} hours.", textParams[0], textParams[1])
        ], [
        textParams
    ]);
}
export { useFomoCouponText };
